import Vue from 'vue'
import App from './App.vue'
import createRouter from './router'
import store from '@/plugins/vuex/store'
import i18n from '@/plugins/i18n'

import './plugins/vee-validate'
import './index.scss'
import './plugins/otp'
import './plugins/vue-countdown'
import './plugins/picker'

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
var infiniteScroll = require('vue-infinite-scroll')
Vue.use(infiniteScroll)

Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999,
  },
})

export const bus = new Vue()

// 👉 Load router trước, rồi mới mount app
createRouter().then((router) => {
  new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
  }).$mount('#app')
})
